// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tiles_wrapper__rvzVL","title":"tiles_title__mqzY1","text":"tiles_text__nP_l6","grid":"tiles_grid__kM6ci","item":"tiles_item__WMh7s"};